/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_How_1_DescInputs */

const en_vc_onl_how_1_desc = /** @type {(inputs: Vc_Onl_How_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything happens inside your browser. Your drawings are never uploaded to a server.`)
};

const zh_vc_onl_how_1_desc = /** @type {(inputs: Vc_Onl_How_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一切都在浏览器里完成，你的作品不会上传到任何服务器。`)
};

/**
* | output |
* | --- |
* | "Everything happens inside your browser. Your drawings are never uploaded to a server." |
*
* @param {Vc_Onl_How_1_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_how_1_desc = /** @type {((inputs?: Vc_Onl_How_1_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_How_1_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_how_1_desc(inputs)
	return zh_vc_onl_how_1_desc(inputs)
});
export { vc_onl_how_1_desc as "vc.onl.how.1.desc" }